<template>
    <b-tab title="Campos Novos">
        <limits-management
            v-if="canChangeSensorsLimits"
            :source="source"
            :reading-kinds="readingKinds"
        />
        <sensor-formula-management
            v-if="canChangeSensorsFormulas"
            :source="source"
        />
    </b-tab>
</template>

<script>
import LimitsManagement from "../common/LimitsManagement";
import SensorFormulaManagement from "../common/SensorFormulaManagement";
import {
    SENSOR_LABELS,
    SENSOR_UNITS,
    SOURCE
} from "@/modules/campos_novos/settings";
import createSpecialPermissionsMixin from "@/modules/settings/mixins/createSpecialPermissionsMixin";

const dam = "campos_novos";
const specialPermissionsMixin = createSpecialPermissionsMixin(dam);

export default {
    name: "CamposNovosTab",
    components: {
        LimitsManagement,
        SensorFormulaManagement
    },
    mixins: [specialPermissionsMixin],
    props: {
        permissions: {
            type: Array,
            required: true,
            validator(value) {
                return (
                    value.length > 0 && value.every(name => name.includes(dam))
                );
            }
        }
    },
    created() {
        this.source = SOURCE;
        const readingKinds = {};
        Object.keys(SENSOR_UNITS).forEach(sensorKind => {
            readingKinds[sensorKind] = {};
            Object.keys(SENSOR_UNITS[sensorKind]).forEach(sensorReadingKind => {
                readingKinds[sensorKind][
                    sensorReadingKind
                ] = `${SENSOR_LABELS[sensorKind][sensorReadingKind]} (${SENSOR_UNITS[sensorKind][sensorReadingKind]})`;
            });
        });
        this.readingKinds = readingKinds;
    }
};
</script>
